import { createIcon } from '@chakra-ui/icon'

const NotAllowedGraphic = createIcon({
  viewBox: '0 0 260 200',
  path: (
    <g>
      <defs>
        <style>
          {
            '.st1{fill:#5f7970}.st4{fill:#5ba8f8}.st5{fill:#1876b5}.st9{fill:#87c5f9}'
          }
        </style>
      </defs>
      <g>
        <path
          d="M234.6 78.2c-4.1-2.7-8.6-4.9-13.1-6.7-9.2-3.7-18.6-5.8-26.2-7.2 3.9-10.2 4.2-19.6.1-27.1C182 12.7 109.2 1.5 57.6 35.9-9 80.3.7 134.4 4.9 147.4c1.1 3.3 4.3 9.9 9.7 16.6 5 6.3 11.9 12.7 20.6 16.6 4.3 1.9 9.2 3.9 14.8 5.6 1.3.4 2.6.8 4 1.2.6.2 1.3.4 1.9.6 4.1 1.2 8.5 2.2 13.2 3.2 15.6 3.2 34.7 5.3 58 5.3 51.6 0 79.9-16.4 79.9-16.4h-.3c.9-.5 1.7-1 2.3-1.3 3.3-1.6 6.5-3.4 9.7-5.2 2.3-1.4 8-4.9 14.3-10.5 9.7-8.7 20.8-22.5 22.5-41 2.2-21.7-7.7-35.2-20.9-43.9z"
          style={{ fill: '#dbf9ed' }}
        />
        <path
          d="M43.3 154.3c1 1.2 1.9 2.4 2.8 3.7.4.7.8 1.3 1.2 2.1l.3.6.2.6c.1.2.1.5.2.7.1.3.1.6.1.9l-2.2-.2c0-.7-.1-1.4-.4-2.1-.2-.7-.5-1.4-.8-2.1-.6-1.4-1.3-2.7-2-4l.6-.2z"
          className="st1"
        />
        <path
          d="M44.7 156.3s-2.6-3.1-14.3-5.6c-11.8-2.6-31.3-11.8-28-20.9 3.2-9.1 25.5-3.6 34.1 7.3 8.6 10.9 8.2 19.2 8.2 19.2z"
          style={{ fill: '#64c99f' }}
        />
        <path
          d="m43.8 155.2-.5.3c-11-18.5-30.8-21.4-31-21.4l.1-.6c.2 0 20.3 3 31.4 21.7zM42.3 163.7c.8.2 1.6.5 2.3.8l1.2.6c.2.1.4.3.6.4l.3.3c.1.1.2.3.3.5l-2 .8c-.1-.3-.3-.6-.6-.8-.2-.3-.5-.5-.8-.8-.6-.5-1.2-.9-1.8-1.4l.5-.4z"
          className="st1"
        />
        <path
          d="M43.3 164.5s-1.8-.8-7.8.5c-5.9 1.4-16.8 1.4-17.3-3.5-.5-4.8 10.8-7.2 17.1-4 6.4 3.1 8 7 8 7z"
          style={{ fill: '#f9cc7d' }}
        />
        <path
          d="m42.7 164.1-.3.5c-8.9-6-18.5-3.1-18.6-3l-.2-.6c.1-.1 9.9-3.1 19.1 3.1z"
          className="st1"
        />
        <path
          d="M213 63.6c-.8-.3-1.6-.4-2.5-.4H55.1c-4.3 0-7.8 3.5-7.8 7.8v101c0 4 3 7.3 6.9 7.7h156.3c4.3 0 7.8-3.5 7.8-7.8v-101c0-3.4-2.2-6.3-5.3-7.3z"
          className="st4"
        />
        <path
          d="M210.5 63.2H55.1c-4.3 0-7.8 3.5-7.8 7.8v8h171v-8.1c0-4.3-3.5-7.7-7.8-7.7z"
          className="st5"
        />
        <path
          d="M73.7 68.4c-1.5 0-2.6 1.2-2.6 2.6 0 1.5 1.2 2.6 2.6 2.6 1.5 0 2.6-1.2 2.6-2.6.1-1.4-1.1-2.6-2.6-2.6z"
          style={{ fill: '#62a4a1' }}
        />
        <path
          d="M66.8 68.4c-1.5 0-2.6 1.2-2.6 2.6 0 1.5 1.2 2.6 2.6 2.6 1.5 0 2.6-1.2 2.6-2.6.1-1.4-1.1-2.6-2.6-2.6z"
          style={{ fill: '#ffda04' }}
        />
        <path
          d="M59.7 68.4c-1.5 0-2.6 1.2-2.6 2.6 0 1.5 1.2 2.6 2.6 2.6 1.5 0 2.6-1.2 2.6-2.6.1-1.4-1.1-2.6-2.6-2.6z"
          style={{ fill: '#cf3045' }}
        />
        <path
          d="M54.2 179.7H126.8L147.9 79h-58C78 112.3 62.3 156.5 54.2 179.7zM152.9 179.7h42.7L210.7 79h-32.3c-8.4 33.1-19.7 77.3-25.5 100.7z"
          className="st9"
        />
        <circle cx="132.8" cy="127.8" r="25.5" style={{ fill: '#fff' }} />
        <path
          d="M132.8 114.9c-3.9 0-7.1 3.2-7.1 7.1v5.9h2.6V122c0-2.5 2-4.4 4.4-4.4 2.5 0 4.4 2 4.4 4.4v5.9h2.6V122c.2-4-3-7.1-6.9-7.1z"
          className="st4"
        />
        <path
          d="M140.8 125.2h-16.1c-.2 0-.3.1-.3.3v15c0 .1.1.3.3.3h16.1c.2 0 .3-.1.3-.3v-15c0-.2-.1-.3-.3-.3z"
          className="st4"
        />
        <path
          d="M135 131.3c0-1.2-1-2.3-2.3-2.3-1.2 0-2.3 1-2.3 2.3 0 .7.3 1.3.7 1.7l-.5 4.1h3.9l-.4-4c.6-.6.9-1.2.9-1.8z"
          className="st5"
        />
      </g>
    </g>
  ),
})

export default NotAllowedGraphic
